import React from "react";

import { cn } from "../cn";

export function RedesignInfoRow({ label, children, className, "data-testid": testId }: { label: React.ReactNode; children: React.ReactNode; className?: string; "data-testid"?: string }) {
  return (
    <div className={cn("tw-flex tw-flex-col tw-gap-[5px]", className)} data-testid={testId}>
      <span className="tw-font-sans tw-text-sm tw-font-semibold tw-leading-5 tw-text-foreground">{label}</span>
      <span className="tw-font-sans tw-text-sm tw-font-normal tw-leading-5 tw-text-foreground">{children}</span>
    </div>
  );
}
